/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

interface UseIsScrollingProps {
  ref: React.RefObject<HTMLElement>;
  useParent?: boolean;
}

// Hook to determine if an element is being scrolled
function useIsScrolling(props: UseIsScrollingProps) {
  const { ref, useParent = false } = props;

  const [isScrolling, setIsScrolling] = useState(false);

  const handleScroll = () => {
    const refElement = useParent ? ref?.current?.parentElement : ref?.current;
    if (refElement && refElement.scrollTop > 0) {
      setIsScrolling(true);
    } else {
      setIsScrolling(false);
    }
  };

  useEffect(() => {
    const refElement = useParent ? ref?.current?.parentElement : ref?.current;
    if (refElement) {
      refElement.addEventListener('scroll', handleScroll);
      return () => {
        refElement.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);

  return { isScrolling };
}

export { useIsScrolling };
